











































































import Vue from "vue";
// components
import HomeAnalyticsView from "@/features/home/homeAnalyticsView.vue";
import HomeScrapingView from "@/features/home/homeScrapingView.vue";
import HomeFilterCard from "@/features/home/components/homeFilterCard.vue";
import HomeDateTimeCard from "@/features/home/components/homeDateTimeCard.vue";
import DialogCard from "@/commons/components/DialogCard.vue";
// api
import { getPublishers } from "@/commons/axios/publisher";
import {
  getOverallTrends,
  getDemandSales,
  getCPMTransition,
  getAdData,
  getClients,
  getAuctionTime,
  getLatestDataDate,
} from "@/features/home/axios";
// types
import { AxiosResponse } from "axios";
import { PublishersResponse } from "@/commons/types";
import {
  Client,
  Publisher,
  AdData,
  OverallTrends,
  DemandSales,
  DemandSalesTable,
  CPMTransition,
  AuctionTime,
  AdDataResponse,
  OverallTrendsResponse,
  DemandSalesResponse,
  CPMTransitionResponse,
  AuctionTimeResponse,
  ClientsResponse,
  LatestDataDateResponse,
} from "@/features/home/types";
// util
import * as notifyUtil from "@/commons/utils/notifyUtil";
import {
  processOverallTrends,
  processDemandSales,
  processCPMTransition,
  processAuctionTime,
} from "@/features/home/utils/fetchedDataProcess";
import {
  getDateSevenDaysAgo,
  getDateTargetDaysAgoFromTargetDate,
  isAfterTargetDate,
} from "@/commons/utils/dateHandling";
import { isPeriodSpecification } from "@/features/home/utils";
// enum
import { AuthorityEnum } from "@/features/setting/enums/Authority";
import { PERIOD, REPORT_TYPE } from "@/commons/enums";

const TAB_TYPE = {
  ANALYTICS: 0,
  SCRAPING: 1,
} as const;

const OMMIT_SIZE = 11;
const DEFAULT_DAYS_AGO = 3;

export default Vue.extend({
  components: {
    "home-analytics-view": HomeAnalyticsView,
    "home-scraping-view": HomeScrapingView,
    "home-filter-card": HomeFilterCard,
    "home-date-time-card": HomeDateTimeCard,
    "dialog-card": DialogCard,
  },
  created() {
    const createdFetch = async () => {
      this.loading = true;
      await this.fetchLatestDataDate();
      await this.fetchPublishers();
      await this.fetchClients();
      await this.fetchData();
      if (!this.showTabChangeDialog) this.loading = false;
    };
    createdFetch();
  },
  data() {
    return {
      loading: false,
      publishers: [] as Publisher[],
      filteredPublishers: [] as Publisher[],
      clients: [] as Client[],
      estimatedRevenue: {
        data: null,
        volatility: null,
        expectedData: null,
      } as AdData,
      impression: {
        data: null,
        volatility: null,
        expectedData: null,
      } as AdData,
      ecpm: {
        data: null,
        volatility: null,
        expectedData: null,
      } as AdData,
      analyticsLatestDataDate: "" as string,
      scrapingLatestDataDate: "" as string,
      overallTrends: {
        labels: [],
        revenue: [],
        impression: [],
      } as OverallTrends,
      demandSales: {
        labels: [],
        revenue: [],
        revenueBreakdown: [],
      } as DemandSales,
      demandSalesTable: [] as DemandSalesTable[],
      cpmTransition: {
        date: [],
        cpm: [],
        avg: [],
      } as CPMTransition,
      auctionTime: {
        labels: [],
        series: [],
        colorList: [],
      } as AuctionTime,
      periodInput: PERIOD.LAST_SEVEN_DAYS.value as typeof PERIOD[keyof typeof PERIOD]["value"],
      publishersInput: [] as number[],
      clientsInput: [] as number[],
      startDateInput: "" as string,
      endDateInput: "" as string,
      tab: TAB_TYPE.ANALYTICS as typeof TAB_TYPE[keyof typeof TAB_TYPE],
      tmpTab: TAB_TYPE.ANALYTICS as typeof TAB_TYPE[keyof typeof TAB_TYPE],
      showTabChangeDialog: false as boolean,
    };
  },
  computed: {
    currency() {
      return this.$store.state.currency;
    },
    publishersFilteredByClients() {
      // クライアントユーザーの場合、クライアントによるパブリッシャーの絞り込みは不要
      if (AuthorityEnum.checkClientByValue(this.$store.getters["auth/getLoginUser"].type)) {
        this.setPublishersInput(this.publishersInput);
        return (this as any).publishers;
      }
      let tmpSelectedPublisherIdList = [] as number[];
      // パブリッシャーに紐づいたクライアントIDが、選択されたクライアントIDと一致するもののみ、パブリッシャーフィルターで選択できるようにする
      this.publishers.forEach((publisher, index) => {
        this.clientsInput.forEach((client: number) => {
          if (
            client !== publisher.clientId &&
            !tmpSelectedPublisherIdList.includes(publisher.publisherId)
          ) {
            (this as any).publishers[index].disabled = true;
          } else {
            tmpSelectedPublisherIdList.push(publisher.publisherId);
            (this as any).publishers[index].disabled = false;
          }
        });
      });
      this.setPublishersInput(
        this.publishersInput.filter((publisher: number) =>
          tmpSelectedPublisherIdList.includes(publisher)
        )
      );
      /**
       * NOTE: v-autocompleteのitem-disabledを使うべきだが,menu-propsで表示件数を拡張すると数秒硬直してしまう
       * そのため暫定的に他のリストに詰め直してセレクトボックスのメニューを更新している
       */
      return (this as any).publishers.filter((publisher: Publisher) => !publisher.disabled);
    },
    reportTypeFromTab() {
      return (this as any).tab === TAB_TYPE.ANALYTICS
        ? REPORT_TYPE.PREBID_ANALYTICS["value"]
        : REPORT_TYPE.BI_REPORT["value"];
    },
    latestDataDateFromTab(): string {
      return (this as any).tab === TAB_TYPE.ANALYTICS
        ? (this as any).analyticsLatestDataDate
        : (this as any).scrapingLatestDataDate;
    },
  },
  methods: {
    initLatestDataDate() {
      // アナリティクス、スクレイピング共にデータの更新が確実に行われている「実行日の3日前」を設定
      let today = new Date();
      this.analyticsLatestDataDate = getDateTargetDaysAgoFromTargetDate(today, DEFAULT_DAYS_AGO);
      this.scrapingLatestDataDate = getDateTargetDaysAgoFromTargetDate(today, DEFAULT_DAYS_AGO);
    },
    initAdData() {
      this.estimatedRevenue =
        this.impression =
        this.ecpm =
          {
            data: null,
            volatility: null,
            expectedData: null,
          };
    },
    initOverallTrends() {
      this.overallTrends.labels.splice(0);
      this.overallTrends.revenue.splice(0);
      this.overallTrends.impression.splice(0);
    },
    initDemandSales() {
      this.demandSalesTable.splice(0);
      this.demandSales.labels.splice(0);
      this.demandSales.revenue.splice(0);
      this.demandSales.revenueBreakdown.splice(0);
    },
    initAuctionTime() {
      this.auctionTime.labels.splice(0);
      this.auctionTime.series.splice(0);
      this.auctionTime.colorList.splice(0);
    },
    initCPMTransition() {
      this.cpmTransition.date.splice(0);
      this.cpmTransition.cpm.splice(0);
      this.cpmTransition.avg.splice(0);
    },
    setPublishersInput(value: number[]) {
      this.publishersInput = value;
    },
    setStartDateInput(startDate: string) {
      this.startDateInput = startDate;
    },
    setEndDateInput(endDate: string) {
      this.endDateInput = endDate;
    },
    clickOkOnTabChangeDialog() {
      this.showTabChangeDialog = false;
      // 選択できない日付のみ、選択可能な最後の日付に押し込める
      if (isAfterTargetDate(this.startDateInput, this.latestDataDateFromTab)) {
        // 開始日のみ、または開始日・終了日両方が選択できない日付の場合
        this.setStartDateInput(this.latestDataDateFromTab);
        this.setEndDateInput(this.latestDataDateFromTab);
      } else if (isAfterTargetDate(this.endDateInput, this.latestDataDateFromTab)) {
        // 終了日のみ選択できない日付の場合
        this.setEndDateInput(this.latestDataDateFromTab);
      }
      if (this.tab !== this.tmpTab) this.fetchData();
    },
    clickCancelOnTabChangeDialog() {
      this.showTabChangeDialog = false;
      this.tab = this.tmpTab;
      this.loading = false;
    },
    clickTab(targetTab: 0 | 1) {
      this.tmpTab = this.tab;
      this.tab = targetTab;
      if (
        isPeriodSpecification(this.periodInput) &&
        (isAfterTargetDate(this.startDateInput, this.latestDataDateFromTab) ||
          isAfterTargetDate(this.endDateInput, this.latestDataDateFromTab))
      ) {
        this.loading = true;
        this.showTabChangeDialog = true;
      } else this.fetchData();
    },
    async fetchLatestDataDate() {
      await getLatestDataDate()
        .then((response: AxiosResponse<LatestDataDateResponse>) => {
          this.analyticsLatestDataDate = response?.data.latestDataDate.analytics;
          this.scrapingLatestDataDate = response?.data.latestDataDate.scraping;
        })
        .catch(error => {
          if (error.response?.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.latestDataDate"));
            this.initLatestDataDate();
          }
        });
    },
    async fetchPublishers() {
      await getPublishers()
        .then((response: AxiosResponse<PublishersResponse>) => {
          this.publishers = response?.data.publishers;
        })
        .catch(error => {
          if (error.response?.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.publishers"));
        });
    },
    async fetchClients() {
      await getClients()
        .then((response: AxiosResponse<ClientsResponse>) => {
          this.clients = response?.data.clients;
        })
        .catch(error => {
          if (error.response?.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.clients"));
        });
    },
    async fetchAdData() {
      await getAdData(
        this.periodInput,
        this.reportTypeFromTab,
        this.publishersInput,
        this.clientsInput,
        this.startDateInput,
        this.endDateInput,
        this.currency,
      )
        .then((response: AxiosResponse<AdDataResponse>) => {
          this.estimatedRevenue = response?.data.adData[0].estimatedRevenue;
          this.impression = response?.data.adData[0].impression;
          this.ecpm = response?.data.adData[0].ecpm;
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.adData"));
            this.initAdData();
          }
        });
    },
    async fetchOverallTrends() {
      await getOverallTrends(
        this.periodInput,
        this.reportTypeFromTab,
        this.publishersInput,
        this.clientsInput,
        this.startDateInput,
        this.endDateInput,
        this.currency,
      )
        .then((response: AxiosResponse<OverallTrendsResponse>) => {
          this.initOverallTrends();
          this.overallTrends = processOverallTrends(response?.data);
        })
        .catch(error => {
          if (error.response?.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.overallTrends"));
            this.initOverallTrends();
          }
        });
    },
    async fetchDemandSales() {
      await getDemandSales(
        this.periodInput,
        this.reportTypeFromTab,
        this.publishersInput,
        this.clientsInput,
        this.startDateInput,
        this.endDateInput,
        this.currency,
      )
        .then((response: AxiosResponse<DemandSalesResponse>) => {
          this.initDemandSales();
          const { chart, table } = processDemandSales(
            response?.data,
            OMMIT_SIZE,
            String(this.$t("home.text.demandSale.summarizedVendorName"))
          );
          this.demandSales = chart;
          this.demandSalesTable = table;
        })
        .catch(error => {
          if (error.response?.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.demandSales"));
            this.initDemandSales();
          }
        });
    },
    async fetchAuctionTime() {
      await getAuctionTime(
        this.periodInput,
        this.publishersInput,
        this.clientsInput,
        this.startDateInput,
        this.endDateInput
      )
        .then((response: AxiosResponse<AuctionTimeResponse>) => {
          this.auctionTime = processAuctionTime(response?.data);
        })
        .catch(error => {
          if (error.response?.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.auctionTimes"));
            this.initAuctionTime();
          }
        });
    },
    async fetchCPMTransition() {
      await getCPMTransition(
        this.periodInput,
        this.reportTypeFromTab,
        this.publishersInput,
        this.clientsInput,
        this.startDateInput,
        this.endDateInput,
        this.currency,
      )
        .then((response: AxiosResponse<CPMTransitionResponse>) => {
          this.initCPMTransition();
          this.cpmTransition = processCPMTransition(response?.data);
        })
        .catch(error => {
          if (error.response?.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.cpmTransitions"));
            this.initCPMTransition();
          }
        });
    },
    async fetchData() {
      this.loading = true;

      // アカウントがクライアントユーザー以外でフィルターでクライアントが選択されていない場合、パブリッシャーも選択しないようにする
      if (
        this.clientsInput.length === 0 &&
        !AuthorityEnum.checkClientByValue(this.$store.getters["auth/getLoginUser"].type)
      )
        this.publishersInput.splice(0);

      if (this.tab === TAB_TYPE.ANALYTICS) {
        await Promise.all([
          this.fetchAdData(),
          this.fetchOverallTrends(),
          this.fetchDemandSales(),
          this.fetchAuctionTime(),
          this.fetchCPMTransition(),
        ]);
      }
      if (this.tab === TAB_TYPE.SCRAPING) {
        await Promise.all([
          this.fetchAdData(),
          this.fetchOverallTrends(),
          this.fetchDemandSales(),
          this.fetchCPMTransition(),
        ]);
      }
      if (!this.showTabChangeDialog) this.loading = false;
    },
  },
  watch: {
    periodInput() {
      if (isPeriodSpecification(this.periodInput)) {
        this.setEndDateInput(this.latestDataDateFromTab);
        this.setStartDateInput(getDateSevenDaysAgo(this.endDateInput));
      } else {
        this.setStartDateInput("");
        this.setEndDateInput("");
      }
    },
    currency() {
      this.fetchData();
    },
  },
});
